import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './locales/en/translation.json';
import ko from './locales/ko/translation.json';
import es from './locales/es/translation.json';
import fr from './locales/fr/translation.json';
import de from './locales/de/translation.json';
import zh from './locales/zh/translation.json';
import ja from './locales/ja/translation.json';
import hi from './locales/hi/translation.json';
import ar from './locales/ar/translation.json';
import he from './locales/he/translation.json';
import pt from './locales/pt/translation.json';
import it from './locales/it/translation.json';
import nl from './locales/nl/translation.json';
import ru from './locales/ru/translation.json';
import id from './locales/id/translation.json';
import ms from './locales/ms/translation.json';
import fil from './locales/fil/translation.json';
import tr from './locales/tr/translation.json';
import bn from './locales/bn/translation.json';
import ta from './locales/ta/translation.json';
import { getInitialI18nLanguage } from './utils/publicLanguage';
import { isRtlLanguage, normalizeLanguageCode } from './utils/languagePairPolicy';

const resources = {
  en: { translation: en },
  ko: { translation: ko },
  es: { translation: es },
  fr: { translation: fr },
  de: { translation: de },
  zh: { translation: zh },
  ja: { translation: ja },
  hi: { translation: hi },
  ar: { translation: ar },
  he: { translation: he },
  pt: { translation: pt },
  it: { translation: it },
  nl: { translation: nl },
  ru: { translation: ru },
  id: { translation: id },
  ms: { translation: ms },
  fil: { translation: fil },
  tr: { translation: tr },
  bn: { translation: bn },
  ta: { translation: ta },
};

const detectLanguage = () => {
  const preferred = getInitialI18nLanguage();
  return resources[preferred] ? preferred : 'en';
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: detectLanguage(),
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

const syncDocumentLanguage = (language) => {
  if (typeof document === 'undefined') return;
  const normalized = normalizeLanguageCode(language) || 'en';
  document.documentElement.lang = normalized;
  document.documentElement.dir = isRtlLanguage(normalized) ? 'rtl' : 'ltr';
};

syncDocumentLanguage(i18n.language);
i18n.on('languageChanged', syncDocumentLanguage);

export default i18n;
